import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z.object({
  type: z.enum(['subscription', 'free-trial']),
  subscription: z.object({
    percent: z.string().optional(),
    duration: z.string().optional(),
  }),
  freeTrial: z.object({
    duration: z.string().optional(),
    offerExpiration: z.string().optional(),
  }),
})

export type PromotionalOfferForFanFormValues = z.infer<typeof schema>

export const PROMOTIONAL_OFFER_FOR_FAN_FORM_ID =
  'promotional-offer-for-fan-form'
export const promotionalOfferForFanFormResolver = zodResolver(schema)
